module.exports = __webpack_public_path__ + "static/media/vibrating-headphone 1.12777f6b.png";